<template>
  <b-row>
    <flash-message transitionIn="animated swing"></flash-message>
    <b-col cols="12" xl="12">
      <b-card>
        <div slot="header">
          Add news
        </div>
        <b-card-body>
          <news-form :news="news" :add-option="true"></news-form>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
  import {News} from "../../models/News/News";
  import NewsForm from "../../components/News/NewsForm";

  export default {
      name: 'add-news',
      components: {
        NewsForm
      },
      data: () => {
        return {
          news: new News(),
        }
      },
  }
</script>
